import AdsenseForSearchBlock from "./AdsenseForSearchBlock";

declare global {
    interface Window {
        _googCsa: Function;
    }
}

const AFS_CONTAINER_CLASS = ".afs-container";
const AFS_SKELETON_CLASS = ".skeleton-screen-container";

class GoogleAdsenseForSearch {

    private readonly googleCsa: Function;
    private readonly dom: any;

    constructor(googleCsa: Function, dom: any) {
        this.googleCsa = googleCsa;
        this.dom = dom;
    }

    init() {
        let pageOptions = {};
        window.addEventListener('load', () => {
            if (typeof this.googleCsa !== 'undefined') {
                const afsBlocks: any[] = [];
                this.dom.selectAll(AFS_CONTAINER_CLASS)?.forEach((containerEl: Element) => {
                    const numberOfAfs = parseInt(containerEl.getAttribute("data-number-of-afs")!!, 10);
                    const isTopAfs = JSON.parse(containerEl.getAttribute("data-top-afs") as string) as boolean;
                    const afsBlock = new AdsenseForSearchBlock(
                        containerEl.id,
                        numberOfAfs,
                        isTopAfs,
                    ).toPlainObject();
                    pageOptions = JSON.parse(containerEl.getAttribute("data-page-options")!!);
                    afsBlocks.push({
                        ...afsBlock,
                        adLoadedCallback: this.afsLoadedCallback.bind(this),
                        noAdLoadedCallback: this.noAfsLoadedCallback.bind(this),
                    });
                });
                if (afsBlocks.length > 0) {
                    this.googleCsa('ads', pageOptions, ...afsBlocks);
                }
            } else {
                console.error("_googCsa is undefined");
            }
        });
    }

    private afsLoadedCallback = (container: string, afsLoaded: boolean): void => {
        if (afsLoaded) {
            this.hideSkeletonBlock();
            this.adaptAfsBlockSkeletonHeight(container);
            this.displayAfsBlock(container);
        } else {
            this.hideAfsBlock(container);
        }
    }

    private noAfsLoadedCallback = (container: string, _afsLoaded: boolean): void => {
        this.hideSkeletonBlock();
    }

    private hideSkeletonBlock = (): void => {
        this.dom.selectAll(AFS_SKELETON_CLASS)?.forEach((skeletonEl: HTMLElement) => {
            skeletonEl.style.display = 'none';
        });
    }

    private adaptAfsBlockSkeletonHeight = (container: string): void => {
        const parentContainer = this.dom.select(`#afs-container-father-${container}`) as HTMLElement;
        if (parentContainer) {
            parentContainer.style.height = this.dom.select(container)?.getBoundingClientRect().height + 'px';
        }
    }

    private hideAfsBlock = (container: string): void => {
        const parentContainer = this.dom.select(`#afs-container-father-${container}`) as HTMLElement;
        if (parentContainer) {
            parentContainer.style.display = 'none';
        }
    }

    private displayAfsBlock = (container: string): void => {
        const parentContainer = this.dom.select(`#afs-container-father-${container}`) as HTMLElement;
        if (parentContainer) {
            parentContainer.style.display = 'block';
        }
    }
}

export default GoogleAdsenseForSearch
